import * as React from 'react';
import {Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {sourcesLinks} from '~/modules/Sources/links';
import {SourcesView} from '~/modules/Sources/views/SourcesView';
import {SourceView} from '~/modules/Sources/views/SourceView';

export const SourcesRoute = () => (
    <Breadcrumb breadcrumb={{
        title: 'Sources',
        to: sourcesLinks.sources()
    }}>
        <Routes>
            <Route index element={<SourcesView/>}/>
            <Route path=":sourceId" element={<SourceView/>}/>
        </Routes>
    </Breadcrumb>
);
